/**
 * Base Data
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */

/**
 * User Information
 */
export class User {
    userId: string;
    userName: string;
    sessionId: string;
    authorizationId: string;
    roleIds: Array<string>;
    loginTime: string;
}

/**
 * Error Message
 */
export class ErrorMessage {
    public errorCode: string;
    public errorMessage: string;
    public referenceId: string;

    /**
     * Initialize
     */
    constructor() {
    }
}

/**
 * Base Request
 */
export class BaseRequest {
    public userInfo: User;

    /**
     * Initialize
     */
    constructor() {
    }
}

/**
 * Base Response
 */
export class BaseResponse {
    public request: BaseRequest;
    public errorList: Array<ErrorMessage>;

    /**
     * Initialize
     */
    constructor() {
        this.errorList = [];
    }
}

/**
 * Event
 */
export class Event {
    sourceId: string;
    targetId: string;
    eventId: string;
    data: any;
}

/**
 * Name/Value Pair
 */
export class NameValuePair {
    public name: string;
    public value: string;
}

/**
 * Global Base Constants
 */

/**
 * Notification Type Constants
 */
export const NotificationType = {
    NOTICE: "notice",
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info"
};

/**
 * HTTP Method Constants
 */
export const HTTPMethod = {
    GET: "GET",
    POST: "POST"
};

/**
 * HTTP Content Type Constants
 */
export const HTTPContentType = {
    JSON: "application/json",
    DEFAULT: "application/x-www-form-urlencoded"
};

/**
 * Internationalization Type
 */
export const I18NGroup = {
    GLOBAL: "global",
    FUNCTION: "function"
};
